var validateTextField = require('../common/validate-textfield');
var base = require('../common/base-url');
var whitelist = require('../common/input-chars-whitelist');
require('../common/trim');

window.iq = window.iq || {};
window.iq.domain = window.iq.domain || 'error-no-domain';

module.exports = {
	init: function () {
		if (window.jQuery('#emailForwardingForm').length > 0) {
			window.jQuery('#alias').on('keyup change', function () {
				var pattern = /([^a-z0-9\-._.!#$%&'*+-/=?^_`{|}~])+/gi;
				whitelist(window.jQuery(this), pattern);
				// var cleanAlias = window.jQuery('#alias').val().replace(pattern, '');
				// window.jQuery('#alias').val(cleanAlias);
			});

			window.jQuery('#emailForwardingForm').on('submit', submitForwarding);
		}
	}
};

function submitForwarding(e) {
	e.preventDefault();

	var domain = window.iq.domain;
	var error = false;

	if (endsWithDomain(window.jQuery('#forwardingEmail').val())) {
		window.jQuery('#emailError').html("Whoops! Your forwarding email can't be an " + domain + ' address.');
		window.jQuery('#forwardingEmail').closest('.errorContainer').addClass('error');
		return false;
	}

	error = validateTextField('#emailForwardingForm .requireText') || error;
	if (error) {
		return false;
	}

	isUniqueAlias(window.jQuery('#alias').val());

	return false;
}

function endsWithDomain(val) {
	var domain = window.iq.domain;
	var domainLen = domain.length;
	var ending = val.trim().slice(-1 * domainLen);

	if (ending.toLowerCase() === domain.trim().toLowerCase()) {
		return true;
	}
	return false;
}

function isUniqueAlias(alias) {
	window.jQuery
		.ajax({
			url: base + '/profile/checkUniqueAlias?alias=' + encodeURIComponent(alias),
			contentType: 'application/json; charset=utf-8',
			type: 'POST',
			dataType: 'json'
		})
		.fail(function (jqXHR, textStatus, errorMessage) {
			alert("Sorry, there was an error when we tried to confirm your alias' uniqueness. Please try again.");
		})
		.done(function (data, textStatus, jqXHR) {
			if (data.ISUNIQUE === true && data.ISAPPROPRIATE === true) {
				claimAlias();
			} else if (!data.ISUNIQUE) {
				window.jQuery('#aliasError').html('Whoops! That alias is already taken.');
				window.jQuery('#alias').closest('.errorContainer').addClass('error');
			} else if (!data.ISAPPROPRIATE) {
				window.jQuery('#aliasError').html('Whoops! That alias is not allowed');
				window.jQuery('#alias').closest('.errorContainer').addClass('error');
			}
		});
}

function claimAlias() {
	window.location.href = base + '/profile/saveForwarding?' + window.jQuery('#emailForwardingForm').serialize();
}
